document.addEventListener("DOMContentLoaded", async () => {
  console.log("✅ zg-upsell.js chargé");

  const modal = document.getElementById("zg-upsell-modal");
  if (!modal) return;

  // =========================
  // CONFIG
  // =========================
  const MONTAGE_HANDLE = "montage-de-pneus";
  const PPC_PREFIX = "Garage Pneu Pas Cher";
  const PARALLELISME_VARIANT_ID = 62635509875059;
  const PARALLELISME_PRICE = 55; // €, affiché en permanence sur le toggle

  function parallelismeHelpLinkText() {
    let s =
      (window.zgParallelismeDrawerStrings && window.zgParallelismeDrawerStrings.helpLink) ||
      "Qu'est ce qu'un parallélisme ?";
    s = String(s);
    /* Chaîne parfois double-échappée (Liquid / éditeur de langues) */
    s = s
      .replace(/&amp;#(?:39|039);/gi, "'")
      .replace(/&#(?:39|039);/g, "'")
      .replace(/&apos;/gi, "'");
    return s;
  }

  // Règle 2 (pneus + batterie) : liste fixe autorisée
  const MIXED_ALLOW_GARAGES = [
    "Garage Autocomptoir (St Paul)",
    "Garage Autocomptoir (St Leu)",
    "Garage Centre Zot Garages (St paul)",

    // PPC locations (sans suffix)
    "Garage Pneu Pas Cher (Saint-Denis)",
    "Garage Pneu Pas Cher (Saint-Paul)",
    "Garage Pneu Pas Cher (Saint-Pierre)",
    "Garage Pneu Pas Cher (Tampon)",
    "Garage Pneu Pas Cher (Le Gol)",
    "Garage Pneu Pas Cher (Saint-Louis)",
  ];

  const LARGE_RIM_DENY_GARAGES = [

    "Garage CERAR (Saint Marie)"

  ];

  const RUNFLAT_KEYWORDS = ["RUNFLAT", "RUN FLAT", "RFT", "ROF", "SSR", "ZP", "HRS", "DSST"];

  // ✅ RUNFLAT: n'afficher que PPC + Autocomptoir + Centre Zot Garages
  const RUNFLAT_ALLOW_GARAGES = [
    "Garage Autocomptoir (St Paul)",
    "Garage Autocomptoir (St Leu)",
    "Garage Centre Zot Garages",
    // PPC locations autorisées via PPC_PREFIX
  ];

  // =========================
  // DOM
  // =========================
  const grid = document.getElementById("zg-presta-grid");
  const hiddenVariantId = document.getElementById("zg-presta-variant-id");
  const hiddenTitle = document.getElementById("zg-presta-title");

  const confirmBtn = document.getElementById("zg-confirm");
  const cancelBtn = document.getElementById("zg-cancel");
  const skipBtn = document.getElementById("zg-skip");

  const filtersWrap = document.getElementById("zg-sector-filters");
  const clearBtn = document.getElementById("zg-clear-filter");

  // Bouton checkout : uniquement si le thème expose data-zg-checkout (sinon pas d’interception modal)
  const checkoutEl = document.querySelector("[data-zg-checkout]");

  if (!grid || !hiddenVariantId || !hiddenTitle || !confirmBtn) {
    console.warn("❌ Elements manquants (grid/hidden/confirm)");
    return;
  }

  // =========================
  // Si panier NON vide : retirer disabled résiduel sur le bouton lié au modal (optionnel)
  // =========================
  async function syncCheckoutDisabledWithCart() {
    if (!checkoutEl) return;
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());
      const hasItems = (cart.item_count || 0) > 0;
      if (hasItems) {
        checkoutEl.disabled = false;
        checkoutEl.removeAttribute("disabled");
        checkoutEl.setAttribute("aria-disabled", "false");
      }
    } catch (e) {
      // noop
    }
  }

  if (checkoutEl) {
    await syncCheckoutDisabledWithCart();

    const _zgCheckoutWatch = setInterval(() => {
      if (!checkoutEl) return;
      if (checkoutEl.hasAttribute("disabled") || checkoutEl.disabled) {
        syncCheckoutDisabledWithCart();
      }
    }, 800);
  }

  // =========================
  // Checkout "ready" (VISUEL uniquement, si bouton modal présent)
  // =========================
  let upsellReady = false;

  function setCheckoutReady(ready) {
    if (!checkoutEl) return;
    checkoutEl.classList.toggle("zg-checkout-blocked", !ready);
    checkoutEl.setAttribute("data-zg-upsell-ready", ready ? "1" : "0");
  }

  setCheckoutReady(false);

  // =========================
  // Helpers
  // =========================
  const moneyFormat =
    (window.Shopify && window.Shopify.money_format) || "{{amount_with_currency}}";

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2) + " €";
  }

  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  /** Texte entre balises HTML : pas d’échappement des apostrophes (évite l’affichage littéral de &#39;). */
  function escapeHtmlTextContent(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;");
  }

  // split "Garage XXX (Ville) - NORD - Adresse - SUFFIX?" — ville extraite pour affichage + cohérence
  function splitVariantTitle(title) {
    const parts = String(title || "").split(" - ").map((p) => p.trim());
    const garageRaw = parts[0] || "";
    let locality = "";
    let garageName = garageRaw;
    const pm = garageRaw.match(/^(.+?)\s*\(([^)]+)\)\s*$/);
    if (pm) {
      garageName = pm[1].trim();
      locality = pm[2].trim();
    }
    const garageKey = garageRaw.trim();
    const sector = (parts[1] || "").toUpperCase();

    let addressStreet = "";
    let suffix = "";

    if (parts.length >= 3) {
      const last = (parts[parts.length - 1] || "").toUpperCase();
      const isSuffix = last === '< 18"' || last === '> 18"' || last === "RUNFLAT";

      if (isSuffix) {
        suffix = parts[parts.length - 1].trim();
        addressStreet = parts.slice(2, -1).join(" - ").trim();
      } else {
        addressStreet = parts.slice(2).join(" - ").trim();
      }
    }

    const addressGeo =
      addressStreet && locality
        ? `${addressStreet}, ${locality}`
        : addressStreet || locality;

    return { garageKey, garageName, locality, addressStreet, addressGeo, sector, suffix };
  }
  

  function isRunflatText(text) {
    const t = String(text || "").toUpperCase();
    return RUNFLAT_KEYWORDS.some((k) => t.includes(k));
  }

  function extractMaxRimInchesFromText(text) {
    const t = String(text || "").toUpperCase();
    let max = 0;
    const patterns = [/\bR\s*(\d{2})\b/g, /\bZR\s*(\d{2})\b/g];
    for (let i = 0; i < patterns.length; i++) {
      const re = new RegExp(patterns[i].source, "g");
      let m;
      while ((m = re.exec(t)) !== null) {
        const n = Number(m[1]);
        if (n >= 10 && n <= 34 && n > max) max = n;
      }
    }
    return max;
  }

  function cartItemSearchText(item) {
    let s = `${item.product_title || ""} ${item.variant_title || ""}`;
    const props = item.properties;
    if (Array.isArray(props)) {
      props.forEach((x) => {
        s += ` ${x.name || ""} ${x.value || ""}`;
      });
    }
    return s;
  }

  function setConfirmEnabled(enabled) {
    confirmBtn.disabled = !enabled;
    confirmBtn.classList.toggle("is-active", !!enabled);
  }

  let scrollY = 0;


  function openModal() {
    scrollY = window.scrollY || window.pageYOffset;

    modal.classList.add("is-open");
    modal.style.display = "flex";

    document.body.style.position = "fixed";
    document.body.style.top = `-${scrollY}px`;
    document.body.style.left = "0";
    document.body.style.right = "0";
    document.body.style.width = "100%";
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("is-open");
    modal.style.display = "none";

    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    document.body.style.right = "";
    document.body.style.width = "";
    document.body.style.overflow = "";

    window.scrollTo(0, scrollY);
  }

  setConfirmEnabled(false);

  // =========================
  // Cart facts
  // =========================
  async function getCartFacts() {
    try {
      const cart = await fetch("/cart.js").then((r) => r.json());

      let pneusQty = 0;
      let batteriesQty = 0;
      let hasRunflat = false;
      let rimMax = 0;

      (cart.items || []).forEach((item) => {
        const type = (item.product_type || "").toLowerCase();
        const blob = cartItemSearchText(item);

        if (type.includes("pneu")) {
          pneusQty += Number(item.quantity) || 0;
          if (isRunflatText(blob)) hasRunflat = true;
        }

        if (!type.includes("batter")) {
          const r = extractMaxRimInchesFromText(blob);
          if (r > rimMax) rimMax = r;
        }

        if (type.includes("batter")) {
          batteriesQty += Number(item.quantity) || 0;
        }
      });

      const hasPneus = pneusQty > 0;
      const hasBatteries = batteriesQty > 0;

      return {
        pneusQty: Math.max(0, pneusQty),
        batteriesQty: Math.max(0, batteriesQty),
        hasPneus,
        hasBatteries,
        onlyBatteries: hasBatteries && !hasPneus,
        onlyPneus: hasPneus && !hasBatteries,
        mixed: hasPneus && hasBatteries,
        hasRunflat,
        rimMax,
      };
    } catch (e) {
      return {
        pneusQty: 0,
        batteriesQty: 0,
        hasPneus: false,
        hasBatteries: false,
        onlyBatteries: false,
        onlyPneus: false,
        mixed: false,
        hasRunflat: false,
        rimMax: 0,
      };
    }
  }

  // =========================
  // PPC suffix logic
  // =========================
  function wantedPpcSuffix(facts) {
    if (facts.hasRunflat) return "RUNFLAT";
    if (Number(facts.rimMax || 0) >= 18) return '> 18"';
    return '< 18"';
  }

  function pickPpcVariantForGarage(garageKey, facts, allVariants) {
    const want = wantedPpcSuffix(facts).toUpperCase();

    const sameGarage = allVariants.filter((v) => {
      const s = splitVariantTitle(v.title);
      return s.garageKey.toUpperCase() === garageKey.toUpperCase();
    });

    const match = sameGarage.find(
      (v) => (splitVariantTitle(v.title).suffix || "").toUpperCase() === want
    );
    if (match) return match;

    const base = sameGarage.find((v) => !splitVariantTitle(v.title).suffix);
    return base || null;
  }

  function isAllowedMixed(garageName) {
    const g = String(garageName || "").trim().toUpperCase();
    return MIXED_ALLOW_GARAGES.some((x) => g === String(x).toUpperCase());
  }

  function isAllowedRunflat(garageName) {
    const g = String(garageName || "").trim().toUpperCase();
    const isPpc = g.startsWith(PPC_PREFIX.toUpperCase());
    if (isPpc) return true;
    return RUNFLAT_ALLOW_GARAGES.some((x) => g === String(x).toUpperCase());
  }

  function foldTextForGarageMatch(str) {
    try {
      return String(str || "")
        .normalize("NFKC")
        .replace(/[\u2013\u2014\u2212]/g, "-")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    } catch (e) {
      return String(str || "")
        .replace(/\s+/g, " ")
        .trim()
        .toUpperCase();
    }
  }

  /** Jante ≥ 18" + motif dans LARGE_RIM_DENY_GARAGES : includes sur titre variante (normalisé). */
  function isLargeRimVariantDenied(variantTitle) {
    const full = foldTextForGarageMatch(variantTitle);
    return LARGE_RIM_DENY_GARAGES.some((pattern) => {
      const p = foldTextForGarageMatch(pattern);
      return p.length > 0 && full.includes(p);
    });
  }

  // =========================
  // Filters UI (secteurs)
  // =========================
  let activeSector = "";

  function applySectorFilter() {
    const cards = Array.from(grid.querySelectorAll(".zg-presta-card"));
    let visibleCount = 0;

    cards.forEach((card) => {
      const sector = (card.getAttribute("data-sector") || "").toUpperCase().trim();
      const show = !activeSector || sector === activeSector;
      card.style.display = show ? "" : "none";
      if (show) visibleCount++;
    });

    if (clearBtn) clearBtn.style.display = activeSector ? "" : "none";

    let empty = document.getElementById("zg-presta-empty");
    if (!visibleCount && cards.length) {
      if (!empty) {
        empty = document.createElement("div");
        empty.id = "zg-presta-empty";
        empty.textContent = "Aucun prestataire dans ce secteur.";
        grid.parentElement?.insertBefore(empty, grid);
      }
      empty.style.display = "";
    } else if (empty) {
      empty.style.display = "none";
    }
  }

  function setActiveBadge(sector) {
    activeSector = (sector || "").toUpperCase().trim();

    if (filtersWrap) {
      filtersWrap.querySelectorAll(".zg-badge[data-sector]").forEach((b) => {
        const s = (b.getAttribute("data-sector") || "").toUpperCase().trim();
        b.classList.toggle("is-active", !!activeSector && s === activeSector);
      });
    }

    applySectorFilter();
  }

  if (filtersWrap) {
    filtersWrap.querySelectorAll(".zg-badge[data-sector]").forEach((badge) => {
      badge.addEventListener("click", () => {
        const sector = (badge.getAttribute("data-sector") || "").toUpperCase().trim();
        setActiveBadge(activeSector === sector ? "" : sector);
      });
    });
  }
  if (clearBtn) clearBtn.addEventListener("click", () => setActiveBadge(""));

  // =========================
  // Load prestataires
  // =========================
  let variants = [];
  try {
    const product = await fetch(`/products/${MONTAGE_HANDLE}.js`).then((r) => r.json());
    variants = (product.variants || []).map((v) => ({
      id: v.id,
      title: v.title,
      unitPrice: v.price,
    }));

    upsellReady = true;
    setCheckoutReady(true);
  } catch (e) {
    console.error("❌ Erreur chargement prestataires:", e);
    grid.innerHTML = `<div style="opacity:.7;">Impossible de charger les prestataires.</div>`;
    upsellReady = false;
    setCheckoutReady(false);
  }

  // =========================
  // Build list for UI based on rules
  // =========================
  function buildVariantsForUi(facts) {
    const byGarage = new Map();
    const result = [];

    for (const v of variants) {
      const s = splitVariantTitle(v.title);
      const isPpc = s.garageName.toUpperCase().startsWith(PPC_PREFIX.toUpperCase());

      if (facts.hasRunflat && !isAllowedRunflat(s.garageName)) {
        continue;
      }

      // Bloquer les garages interdits pour jantes ≥ 18"

      if (Number(facts.rimMax || 0) >= 18 && isLargeRimVariantDenied(v.title)) {
        continue;
      }

      if (facts.onlyPneus) {
        if (!isPpc) {
          result.push(v);
          continue;
        }
        if (!byGarage.has(s.garageKey.toUpperCase())) {
          const picked = pickPpcVariantForGarage(s.garageKey, facts, variants);
          if (picked) byGarage.set(s.garageKey.toUpperCase(), picked);
        }
        continue;
      }

      if (facts.mixed) {
        if (!isPpc) {
          if (isAllowedMixed(s.garageName)) result.push(v);
          continue;
        }
        if (!isAllowedMixed(s.garageName)) continue;
        if (!byGarage.has(s.garageKey.toUpperCase())) {
          const picked = pickPpcVariantForGarage(s.garageKey, facts, variants);
          if (picked) byGarage.set(s.garageKey.toUpperCase(), picked);
        }
        continue;
      }
    }

    byGarage.forEach((picked) => result.push(picked));

    const seen = new Set();
    return result.filter((v) => {
      const key = String(v.id);
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  // =========================
  // Render
  // =========================
  function renderCards(facts) {
    const list = buildVariantsForUi(facts).sort((a, b) => {
      const aPpc = splitVariantTitle(a.title).garageName.toUpperCase().startsWith(PPC_PREFIX.toUpperCase()) ? 0 : 1;
      const bPpc = splitVariantTitle(b.title).garageName.toUpperCase().startsWith(PPC_PREFIX.toUpperCase()) ? 0 : 1;
      return aPpc - bPpc;
    });

    if (!list.length) {
      grid.innerHTML = `<div style="opacity:.7;">Aucun prestataire disponible.</div>`;
      return;
    }

    const qty = Math.max(1, Number(facts.pneusQty || 0) || 1);

    grid.innerHTML = list
      .map((v) => {
        const { garageName, sector, addressStreet, locality, suffix } = splitVariantTitle(v.title);
        const unit = Number(v.unitPrice) || 0;
        const total = unit * qty;
        const isPpc = garageName.toUpperCase().startsWith(PPC_PREFIX.toUpperCase());

        // ─── Toggle Parallélisme (PPC uniquement)
        // La carte est un <div role="button"> et non un <button>,
        // ce qui permet d'imbriquer ce <button> sans invalider le HTML.
        const parallelismeToggle = isPpc
          ? `<div class="zg-parallelisme-wrap">
               <div class="zg-parallelisme-left">
                 <div class="zg-parallelisme-left__row">
                   <span class="zg-parallelisme-label">Parallélisme</span>
                   <span class="zg-parallelisme-price">+${PARALLELISME_PRICE} €</span>
                   <span class="zg-parallelisme-help-sep" aria-hidden="true">·</span>
                   <button type="button" class="zg-parallelisme-help-trigger">${escapeHtmlTextContent(parallelismeHelpLinkText())}</button>
                 </div>
               </div>
               <button
                 type="button"
                 class="zg-parallelisme-toggle"
                 data-active="false"
                 aria-pressed="false"
                 aria-label="Ajouter le parallélisme"
               >
                 <span class="zg-parallelisme-toggle__track">
                   <span class="zg-parallelisme-toggle__thumb"></span>
                 </span>
                 <span class="zg-parallelisme-toggle__label">Non</span>
               </button>
             </div>`
          : "";

        return `
          <div
            role="button"
            tabindex="0"
            class="zg-presta-card"
            data-vid="${v.id}"
            data-sector="${escapeHtml(sector)}"
            data-parallelisme="false"
            data-is-ppc="${isPpc ? "1" : "0"}"
          >
            <div class="zg-presta-card__head">
              <div class="zg-presta-card__titlewrap">
                <div class="zg-presta-card__title">${escapeHtml(garageName)}</div>

                <div class="zg-presta-card__badges">
                  ${sector ? `<span class="zg-badge zg-badge--sector">${escapeHtml(sector)}</span>` : ""}
                  ${suffix ? `<span class="zg-badge zg-badge--sector">${escapeHtml(suffix)}</span>` : ""}
                </div>

                ${addressStreet ? `<div class="zg-presta-card__addr">${escapeHtml(addressStreet)}</div>` : ""}
                ${locality ? `<div class="zg-presta-card__locality">${escapeHtml(locality)}</div>` : ""}
              </div>
            </div>

            <div class="zg-presta-card__foot">
              <div class="zg-flex-footer">
                <div class="zg-presta-card__total">
                  <div class="zg-presta-card__unitPrice">${escapeHtml(formatMoney(unit))}/ pneu</div>
                </div>
                <div class="zg-presta-card__total">
                  <span class="zg-presta-card__totalPrice">Soit ${escapeHtml(formatMoney(total))}</span>
                  <span class="zg-presta-card__totalLabel">pour ${qty} pneus</span>
                </div>
                <div class="zg-montage-info">
                  <button type="button" class="zg-montage-info-trigger">Que comprend le montage&nbsp;?</button>
                </div>
              </div>

              <div class="zg-presta-card__check" aria-hidden="true"></div>
            </div>

            ${parallelismeToggle}
          </div>
        `;
      })
      .join("");

    // ── Sync état disabled des toggles selon la carte sélectionnée ────────
    function syncToggleStates() {
      grid.querySelectorAll(".zg-parallelisme-toggle").forEach((btn) => {
        const card = btn.closest(".zg-presta-card");
        const isSelected = card.classList.contains("is-selected");
        btn.disabled = !isSelected;
        btn.classList.toggle("is-disabled", !isSelected);
        // Si on désélectionne la carte, remettre le toggle à Non
        if (!isSelected) {
          card.setAttribute("data-parallelisme", "false");
          btn.setAttribute("data-active", "false");
          btn.setAttribute("aria-pressed", "false");
          btn.querySelector(".zg-parallelisme-toggle__label").textContent = "Non";
        }
      });
    }

    // ── Sélection de carte ──────────────────────────────────────────────────
    function selectCard(card) {
      grid.querySelectorAll(".zg-presta-card").forEach((c) => c.classList.remove("is-selected"));
      card.classList.add("is-selected");

      const vid = card.getAttribute("data-vid");
      const selected = list.find((x) => String(x.id) === String(vid));

      hiddenVariantId.value = selected ? String(selected.id) : "";
      hiddenTitle.value = selected ? selected.title : "";

      setConfirmEnabled(!!hiddenVariantId.value);
      syncToggleStates();
    }

    grid.querySelectorAll(".zg-presta-card").forEach((card) => {
      // Clic souris — ignorer toggle parallélisme et lien « Que comprend le montage ? »
      card.addEventListener("click", (e) => {
        if (e.target.closest(".zg-parallelisme-wrap")) return;
        if (e.target.closest(".zg-montage-info")) return;
        selectCard(card);
      });

      // Clavier Enter / Space pour accessibilité (role=button)
      card.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          if (e.target.closest(".zg-montage-info")) return;
          if (e.target.closest(".zg-parallelisme-help-trigger")) return;
          e.preventDefault();
          selectCard(card);
        }
      });
    });

    // ── Toggle Parallélisme ─────────────────────────────────────────────────
    grid.querySelectorAll(".zg-parallelisme-toggle").forEach((btn) => {
      btn.addEventListener("click", (e) => {
        e.stopPropagation(); // ne pas remonter jusqu'au clic carte

        const card = btn.closest(".zg-presta-card");
        // Bloquer si la carte n'est pas sélectionnée
        if (!card.classList.contains("is-selected")) return;

        const current = card.getAttribute("data-parallelisme") === "true";
        const next = !current;

        card.setAttribute("data-parallelisme", String(next));
        btn.setAttribute("data-active", String(next));
        btn.setAttribute("aria-pressed", String(next));
        btn.querySelector(".zg-parallelisme-toggle__label").textContent = next ? "Oui" : "Non";
      });
    });

    // Init : tous les toggles désactivés au départ (aucune carte sélectionnée)
    syncToggleStates();

    applySectorFilter();
  }

  // =========================
  // Interception checkout (GLOBAL + CAPTURE)
  // =========================
  let allowCheckout = false;

  function isCheckoutClick(target) {
    if (!target || !checkoutEl) return false;
    return !!target.closest?.("[data-zg-checkout]");
  }

  if (checkoutEl) {
    document.addEventListener(
      "click",
      (e) => {
        if (allowCheckout) return;
        if (!isCheckoutClick(e.target)) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation?.();

        (async () => {
          await syncCheckoutDisabledWithCart();

          const facts = await getCartFacts();

          if (facts.onlyBatteries || !facts.hasPneus) {
            allowCheckout = true;
            window.location.href = "/checkout";
            return;
          }

          if (!upsellReady || !variants.length) {
            alert("Chargement des centres de montage... Réessaie dans quelques secondes.");
            return;
          }

          hiddenVariantId.value = "";
          hiddenTitle.value = "";
          setConfirmEnabled(false);

          renderCards(facts);
          openModal();
        })();
      },
      true
    );
  }

  // Close
  cancelBtn?.addEventListener("click", () => closeModal());
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });

  // Skip => checkout direct
  skipBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    allowCheckout = true;
    closeModal();
    window.location.href = "/checkout";
  });

  // Confirm => add montage (+ parallélisme si activé) + checkout
  confirmBtn.addEventListener("click", async () => {
    if (confirmBtn.disabled) return;

    const variantId = hiddenVariantId.value || "";
    const prestaName = hiddenTitle.value || "";

    if (!variantId) {
      setConfirmEnabled(false);
      alert("Choisis un prestataire pour continuer.");
      return;
    }

    const facts = await getCartFacts();
    const pneusQty = Math.max(1, Number(facts.pneusQty || 0) || 1);

    const selectedCard = grid.querySelector(`.zg-presta-card[data-vid="${variantId}"]`);
    const wantsParallelisme =
      selectedCard &&
      selectedCard.getAttribute("data-is-ppc") === "1" &&
      selectedCard.getAttribute("data-parallelisme") === "true";

    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Prestataire montage": prestaName,
          "Montage variant_id": variantId,
          "Montage quantité pneus": String(pneusQty),
          "RUNFLAT détecté": facts.hasRunflat ? "Oui" : "Non",
          "Diamètre max (R)": facts.rimMax ? String(facts.rimMax) : "",
          "Parallélisme": wantsParallelisme ? "Oui" : "Non",
        },
      }),
    });

    const itemsToAdd = [
      {
        id: Number(variantId),
        quantity: pneusQty,
        properties: {
          Service: "Montage pneus",
          "Qté pneus": String(pneusQty),
        },
      },
    ];

    if (wantsParallelisme) {
      itemsToAdd.push({
        id: PARALLELISME_VARIANT_ID,
        quantity: 1,
        properties: {
          Service: "Parallélisme",
        },
      });
    }

    await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: itemsToAdd }),
    });

    allowCheckout = true;
    closeModal();
    window.location.href = "/checkout";
  });

  // default filters
  setActiveBadge("");
});